module.exports = __webpack_public_path__ + "static/media/negative_carrier.253941c0.jpg";